import React from "react";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "../../assets/images/logoTrans.png";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaYoutube,
} from "react-icons/fa";

import "./footer.css";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="footer">
        <div className="row align-items-start justify-content-center gap-4 gap-md-0">
          {/* Image Col1 */}
          <div className="col col-12 col-md-6 col-lg-3 d-flex align-items-center justify-content-center justify-content-lg-start">
            <div className="footer-logo-wrap">
              <img
                src={CompanyLogo}
                alt="Company Logo"
                className="footer-logo"
              />
            </div>
          </div>
          {/* Contact Us Col2 */}
          <div className="col col-12 col-md-6 col-lg-3">
            <div className="footer__sectionHeading">Location</div>
            <div className="footer__registeredOffice mb-2">
              <span className="footer__iconContainer">
                <span>
                  <FaMapMarkerAlt />
                </span>
              </span>
              <span>
                B 36/10-44-A, Kevalrya Dham, Durgakund, Varanasi, Uttar Pradesh,
                Code: 09
              </span>
            </div>
            <div className="footer__contactNumber mb-2">
              <span>
                <FaPhoneAlt />
              </span>
              <a href="tel:+91 8810796053">+918810796053</a>
            </div>
            <div className="footer__email">
              <span>
                <FaEnvelope />
              </span>
              <a href="mailto:vicondealer@gmail.com">vicondealer@gmail.com</a>
            </div>
          </div>
          {/* Company Col3 */}
          <div className="col col-12 col-md-6 col-lg-3">
            <div className="footer__sectionHeading">Vicon Products</div>
            <div
              className="footer__aboutUs"
              style={{
                // color: "#ffffff",
                fontWeight: 400,
                cursor: "pointer",
                marginBottom: 8,
              }}
              onClick={() => navigate("/aboutus")}
            >
              About Us
            </div>
            <div
              className="footer__faqs"
              style={{
                // color: "#ffffff",
                fontWeight: 400,
                cursor: "pointer",
                marginBottom: 8,
              }}
              onClick={() => navigate("/faqs")}
            >
              FAQs
            </div>
            <div
              className="footer__policy"
              style={{
                // color: "#ffffff",
                fontWeight: 400,
                cursor: "pointer",
                marginBottom: 8,
              }}
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </div>
          </div>
          {/* Socials Col4 */}
          <div className="col col-12 col-md-6 col-lg-3">
            <div className="footer__sectionHeading">Follow Us</div>
            <div className="footer__socialLinks">
              <a href="https://www.facebook.com/profile.php?id=61590138610424" target="_blank" rel="noopener noreferrer">
                <FaFacebookF className="footer__socialLink" />
              </a>
              <FaInstagram className="footer__socialLink" />
              <a href="https://www.youtube.com/@viconvaranasi" target="_blank" rel="noopener noreferrer">
                <FaYoutube className="footer__socialLink" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
